import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'; // Router를 여기서 사용
import App from './App'; // App 컴포넌트 import
import './index.css'; 

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <Router> {/* App 컴포넌트 외부에서 Router로 감쌈 */}
        <App />
    </Router>
);